import _ from 'lodash';

export class Move {
  rangeLabelY = 18;
  rangePointY = 15;
  distanceY = 4;
  rangeLabelX = 15;
  rangePointX = 10;
  distanceX = 4;

  constructor () {
    this.moveDownObject = this.moveDownObject.bind(this);
    this.moveUpObject = this.moveUpObject.bind(this);
    this.moveLeftObject = this.moveLeftObject.bind(this);
    this.moveRightObject = this.moveRightObject.bind(this);
    this.getTextPosition = this.getTextPosition.bind(this);
    this.getPointPosition = this.getPointPosition.bind(this);
    this.setTextPositionY = this.setTextPositionY.bind(this);
    this.setTextPositionX = this.setTextPositionX.bind(this);
    this.setPathPositionY = this.setPathPositionY.bind(this);
    this.setPathPositionX = this.setPathPositionX.bind(this);
  }

  moveDownObject (box) {
    return box.copy().addY(this.distanceY);
  }

  moveUpObject (box) {
    return box.copy().addY(-this.distanceY);
  }

  moveLeftObject (box) {
    return box.copy().addX(-this.distanceX);
  }

  moveRightObject (box) {
    return box.copy().addX(this.distanceX);
  }

  getTextPosition (position) {
    return position.copy().addX(5).addY(6).toArray();
  }

  getPointPosition (position) {
    return position.copy().addX(9).addY(16);
  }

  setTextPositionY (label, box) {
    _.find(label.children, i => i.nodeType === 'Text')._position.y = box.y1;
  }

  setTextPositionX (label, box) {
    _.find(label.children, i => i.nodeType === 'Text')._position.x = box.x1;
  }

  setPathPositionY (label, box) {
    const path = _.find(label.children, i => i.nodeType === 'Path');
    if (!path) {
      return;
    }

    path.segments[0]._anchor.y = box.y1;
    path.segments[1]._anchor.y = box.y1;
    path.segments[2]._anchor.y = box.y1 + 14;
    path.segments[3]._anchor.y = box.y1 + 14;
  }

  setPathPositionX (label, box) {
    const path = _.find(label.children, i => i.nodeType === 'Path');
    if (!path) {
      return;
    }

    path.segments[0]._anchor.x = box.x1;
    path.segments[1]._anchor.x = box.x1;
    path.segments[2]._anchor.x = box.x1 + 14;
    path.segments[3]._anchor.x = box.x1 + 14;
  }
}
